import { useQuery } from "@tanstack/react-query";
import { fetchPermissionsGroups } from "PFCore/services/admin/permissions_groups/fetch_permissions_groups";

import { adminKeys } from "./query_keys";

export const usePermissionsGroups = (page = 1, perPage = 25) => {
  const queryKey = adminKeys.permissionsGroupsPage(page);

  return useQuery(queryKey, () => fetchPermissionsGroups({ page, perPage }));
};
